export class RemoveSectionFromTemplateError extends Error {
  constructor(
    message: string = 'Failed to remove section from inspection template',
    options?: ErrorOptions
  ) {
    super(message, options);
    this.name = 'RemoveSectionFromTemplateError';
  }
}
